import * as STD from '@emersya/mpa-std';
import * as Basket from '@emersya/mpa-basket';
import * as CM from '@emersya/mpa-components-manager';
import {InputButton, Image, Text, Block, Color} from '@emersya/mpa-components';

export interface IProductOptionTileComponentConfiguration extends InputButton.Configuration {
	readonly option: Basket.Option;
};

export class ProductOptionTileComponent extends InputButton.Component {

	static override getInputEventSubType() {
		const parentClass = (<typeof CM.Component>(<any>this.prototype).__proto__.constructor);
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button', {});
		}
		return parentClass.type;
	};

	readonly option: Basket.Option;

	onMouseEnter() {
		const detailed = <Block.Component>this.component_find('@:detailed');

		// container
		// left ; right
		//
		//
		const container = this.component_DOM.parentElement;
		if (!container) {
			this.component_throwLibraryError('Cannot be orphan and in the DOM in the same time!', {});
		}
		const containerBCR = container.getBoundingClientRect();
		const selfBCR = this.component_DOM.getBoundingClientRect();
		const detailedWidth = detailed.component_DOM.offsetWidth;
		const detailedWidth2 = detailedWidth / 2;


		const isTooSmall = detailedWidth < selfBCR.width;
		const isHittingLeft = isTooSmall ? false : ((selfBCR.x - (detailedWidth2)) < containerBCR.x);
		const isHittingRight = isTooSmall ? false : ((selfBCR.width + (detailedWidth2)) > containerBCR.width);
		const [left, right] = (
			(isTooSmall || (!isHittingLeft && !isHittingRight)) ? ['', ''] :
				isHittingLeft ? ['0', ''] :
					['', '0']
		);
		detailed.component_stylize({
			top: this.component_DOM.offsetHeight + 'px',
			left,
			right
		});
	};

	// onMouseOut() {
	//
	// };

	override async component_initialize() {
		await super.component_initialize();
		const price = this.option.pricingInfo ? (await this.option.pricingInfo.pricing.resolve()).exclTax : 0;
		(<OMSPriceNS.Component>this.component_find('@:default.price')).update(price);
		(<OMSPriceNS.Component>this.component_find('@:detailed.price')).update(price);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IProductOptionTileComponentConfiguration
	) {
		const option = configuration.option;
		const imageURL = option.thumbnail?.type === 'image' ? option.thumbnail.value : null;
		const color = option.thumbnail?.type === 'color' ? option.thumbnail.value : null;
		const priceConfig: OMSPriceNS.Configuration = {};
		const baseConfig = {
			color: <Color.Configuration>{
				color,
				'@isDisabled': !color,
			},
			image: <Image.Configuration>{
				URL: imageURL,
				'@isDisabled': !imageURL,
				'@translations': {
					name: {
						en: `Option icon`,
						fr: `Icône de l'option`
					}
				}
			},
			title: <Text.Configuration>{
				'@translations': {
					text: STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
						a[c] = option.title;
						return a;
					}, {})
				}
			},
			SKU: <Text.Configuration>{
				'@translations': {
					text: STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
						a[c] = option.reference?.value || '';
						return a;
					}, {})
				}
			},
			price: priceConfig,
		}
		configuration['@innerConfigurations'] = Object.assign({
			default: {
				'@innerConfigurations': {
					...baseConfig
				}
			},
			detailed: {
				'@innerConfigurations': {
					...baseConfig
				}
			}
		}, configuration['@innerConfigurations'] || {});
		const VCM = option.pricingInfo?.volumeComputationMethod;
		if (VCM) {
			const suffix = (
				(VCM.boundTo === 'm') ? {
						en: ' per m',
						fr: ' par m'
					} :
					(VCM.boundTo === 'm2') ? {
							en: ' per m²',
							fr: ' par m²'
						} :
						(VCM.boundTo === 'm3') ? {
							en: ' per m³',
							fr: ' par m³'
						} : null
			);
			if (suffix) {
				priceConfig['@translations'] = {
					suffix
				};
			}
		}
		super(descriptor, configuration);
		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.component_DOM.addEventListener('mouseenter', this.onMouseEnter)
		this.option = option;
	};
};
export namespace NS {
	export const Component = ProductOptionTileComponent;
	export type Component = ProductOptionTileComponent;
	export type Configuration = IProductOptionTileComponentConfiguration;
}
import manifestXMLSource from './ProductOptionTile.xml';
import './ProductOptionTile.scss';
import {NS as OMSPriceNS} from '../../oms/Price/OMSPrice';

CM.Manager.declare({
	id: 'product-optionTile',
	type: ProductOptionTileComponent,
	manifest: manifestXMLSource
});
